import { AcquireTokenAuthError } from '../errors';

const adalErrorCodesRequiringInteractiveLogin = ['consent_required', 'interaction_required', 'login_required'];

export type RequiresInteractiveLogin = (err: unknown) => boolean;
export const requiresInteractiveLogin: RequiresInteractiveLogin = (error) =>
  error instanceof AcquireTokenAuthError && adalErrorCodesRequiringInteractiveLogin.includes(error.errorCode);
